export default __webpack_public_path__ + "static/media/sat.6d2afaee.png";